import { css } from '@emotion/core';
import { variables, media, fontBase } from '@domain-group/fe-brary';

export const container = css`
  ${fontBase}
  padding-bottom: 25px;
  color: ${variables.colour.white};
  ${media('>=desktop')} {
    font-size: ${variables.font.h5MobileFontSize};
  }
`;

export const copyright = css`
  line-height: 24px;
  padding-top: 16px;
  padding-bottom: 12px;
  display: block;
  ${media('>=desktop')} {
    display: inline-block;
  }
`;

export const items = css`
  list-style: none;
  ${media('>=desktop')} {
    display: inline-block;
  }
`;

export const item = css`
  padding: 12px 0;
  line-height: 24px;
  ${media('>=desktop')} {
    display: inline-block;
    &::before {
      content: '●';
      padding: 15px;
    }
  }
`;

export const link = css`
  color: ${variables.colour.white};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
